"use client";

import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Block = {
  id: string;
  title: string;
  content: string;
  type: "normal" | "blockquote";
};
type ListItem = {
  id: number;
  blockId: string;
  text: string;
};
const blocks: Block[] = [{
  id: "overview",
  title: "Overview",
  content: "This residential project focused on refreshing key areas of the home while enhancing overall comfort and visual harmony. The renovation centred on three bathrooms, combined with a complete interior repainting that revitalised the entire property.",
  type: "normal"
}, {
  id: "challenge",
  title: "The Challenge",
  content: "The bathrooms required a modern update while maintaining practical functionality and a clean aesthetic that complemented the rest of the house. The project also required careful scheduling to ensure the work was completed efficiently within a short timeframe.",
  type: "normal"
}, {
  id: "approach",
  title: "Our Approach",
  content: "The renovation included the full upgrade of three bathrooms using carefully selected materials and refined finishes. At the same time, the entire house received a professional interior repaint, creating a brighter and more cohesive living environment.",
  type: "normal"
}, {
  id: "result",
  title: "The Result",
  content: "Within just three weeks, the property was transformed into a refreshed and elegant home environment. The updated bathrooms and renewed interiors significantly enhanced both the functionality and the visual appeal of the residence.",
  type: "normal"
}];
const approachList: ListItem[] = [{
  id: 1,
  blockId: "approach",
  text: "Comprehensive system audit and bottleneck identification."
}, {
  id: 2,
  blockId: "approach",
  text: "Phased migration strategy with zero planned downtime."
}, {
  id: 3,
  blockId: "approach",
  text: "Implementation of robust security protocols."
}];
function ContentBlock({
  block,
  index
}: {
  block: Block;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-6">
        {block.title}
      </h2>

      {block.type === "blockquote" ? <blockquote className="border-l-4 border-border pl-6 py-2 my-8 italic font-sans text-lg md:text-xl text-foreground/90">
          <p className="leading-relaxed">{block.content}</p>
        </blockquote> : <p className="font-sans text-base md:text-lg text-foreground leading-relaxed mb-6">
          {block.content}
        </p>}

    </div>;
}
export default function MainContent() {
  return <section id="main-content" className="bg-background ![padding:40px_32px_96px_0px]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16 px-6 md:px-8">
        {blocks.map((block, i) => <ContentBlock key={block.id} block={block} index={i} />)}

        <div className="mt-2 flex justify-start">
          <Link to="https://ksluxury.cloudtech.com.cy/projects/" className="btn-primary">
            Back to Projects
          </Link>
        </div>
        
      </div>


    
    </section>;
}